export * from './mobile.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/mobile/index.ts